import { ActionType, DictionariesActions, DictionariesState } from './interface';

const initialState: DictionariesState = {
	events: {},
	games: {},
	categories: {},
};

export const DictionariesReducer = (state: DictionariesState = initialState, action: DictionariesActions): DictionariesState => {
	switch (action.type) {
		case ActionType.SET_DICTIONARY:
			return {
				...state,
				[action.payload.recordType]: action.payload.recordContent,
			};

		default:
			return state;
	}
};
